import React from 'react'

function B7() {
    return (
        <div>
            <h1>Great!</h1>
        </div>
    )
}

export default B7